import type { TMessages } from '@/types/TMessages'

export const messages = {
  'EXPRESS-MFO': {
    title: 'Подать заявку',
  },
  'ADVANCE-FUNDING': {
    title: 'Подать заявку на кредит',
  },
  AGENT: {
    title: 'Подать заявку',
  },
  common: {
    description: 'Подайте заявку и с вами свяжется наш финансовый менеджер и проконсультирует по всем вопросам',
  },
  form: {
    comment: 'Заявка из Журнала',
  },
} satisfies TMessages
